import { render, staticRenderFns } from "./ByMarketStats.vue?vue&type=template&id=37c4da92&scoped=true"
import script from "./ByMarketStats.vue?vue&type=script&lang=js"
export * from "./ByMarketStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c4da92",
  null
  
)

export default component.exports